import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

interface MinimalSelectProps {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  format?: (val: string) => string;
}

export default function MinimalSelect({
  value,
  options,
  onChange,
  format,
}: MinimalSelectProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative w-[120px]">
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full h-9 px-3 flex items-center justify-between rounded-lg border border-[#E4E7EC] bg-white text-sm text-[#344054] hover:border-[#D0D5DD] transition"
      >
        <span className="truncate">
          {format ? format(value) : value}
        </span>
        <ChevronDown
          className={`w-4 h-4 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 mt-1 w-full rounded-lg border border-[#EAECF0] bg-white shadow-lg max-h-40 overflow-y-auto">
          {options.map((opt) => (
            <div
              key={opt}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className={`px-3 py-2 text-sm cursor-pointer hover:bg-[#F9FAFB] ${
                value === opt ? "bg-[#F2F4F7]" : ""
              }`}
            >
              {format ? format(opt) : opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}